import { createStore } from 'zustand';

import { makeZustandContextStore } from '@/utils/zustandUtils.tsx';

export type ChatMessagingData = {
  isOpen: boolean;
};

export type ChatMessagingState = ChatMessagingData & {
  touched: boolean;
  toggleChat: () => void;
  openChat: () => void;
  closeChat: () => void;
};

const createChatMessagingStore = (initProps: ChatMessagingData) => {
  return createStore<ChatMessagingState>()(set => ({
    ...initProps,
    touched: false,
    toggleChat: () => set(state => ({ isOpen: !state.isOpen, touched: true })),
    openChat: () => set({ isOpen: true, touched: true }),
    closeChat: () => set({ isOpen: false, touched: true }),
  }));
};

export const [, ChatMessagingProvider, useChatMessagingState] =
  makeZustandContextStore<ChatMessagingData, ChatMessagingState>(
    'ChatMessaging',
    createChatMessagingStore,
  );
